module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jmCxn"))).then(() => module.bundle.root('jnagv'));